import { EventItemExtended } from 'queries/events/types';
import { ALARM_ASSIGNED_TYPE } from '../RelatedAlarmModalTable';

export interface UpdateCaseEventItemDataParams {
  ids: string[];
  changeField: ALARM_ASSIGNED_TYPE;
  actualData: EventItemExtended[];
  value: boolean;
}

export const updateCaseEventItemData = ({
  actualData,
  ids,
  changeField,
  value,
}: UpdateCaseEventItemDataParams): EventItemExtended[] => {
  const updatedSingleAlarms = actualData.map((event) => {
    if (!ids.includes(event.id)) {
      return event;
    }
    return {
      ...event,
      [changeField]: value,
    };
  }, [] as EventItemExtended[]);

  return updatedSingleAlarms;
};
